import React from 'react'
import { CSS } from '@dnd-kit/utilities'
import { useSortable } from '@dnd-kit/sortable'
import cx from 'classnames'

const Draggable = ({ drag = false, id, index, children, className, ...rest }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
    data: {
      index
    },
    disabled: !drag
  })

  const style = {
    transform: CSS.Translate.toString(transform),
    transition
  }

  const defaultProps = {
    className: cx('action-draggable', className),
    ...rest,
    style
  }

  const dragHandleProps = {
    ...listeners,
    ...attributes
  }

  if (typeof children === 'function') {
    return (
      <div {...defaultProps} ref={setNodeRef}>
        {children({ dragHandleProps })}
      </div>
    )
  }

  return (
    <div {...defaultProps} {...dragHandleProps} ref={setNodeRef}>
      {children}
    </div>
  )
}

export default Draggable
